module.exports = __webpack_public_path__ + "media/images/flags/64/South-Africa-0351854d06931c7caccee9873a10daba.png";